import React from "react";

import { PrimaryButton } from "../../simple-buttons/simple-buttons";
import { SVGDeclineIcon } from "../../svg-animated/svg-animated";
import DocumentStatus from "./document-status";

const DocumentImagePoorQuality = ({ resetJourney }: { resetJourney: () => Promise<void> }) => {
    return (
        <DocumentStatus
            icon={<SVGDeclineIcon />}
            headingText="Image quality too poor"
            subheadingText="Unfortunately, that didn't work. 
            Please upload your document again, making sure that:"
            listItems={[
                <>The image is not blurry</>,
                <>There is no glare on the image</>,
                <>You can clearly see all 4 corners of your document in the image</>
            ]}
            button={<PrimaryButton onClick={() => resetJourney()} text="Try again" />}
        />
    )
};

export default DocumentImagePoorQuality;
